"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconMessageSequence from "@/app/(components)/generics/Icons/IconMessageSequence";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";
import styles from "./MessagesContentCard.module.css";

type Props = {
  params: PageParams;
};

export default function MessagesContentCard(props: Props) {
  const T = useT();
  const { params } = props;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <IconMessageSequence />
        </div>
        <h4 className={styles.title}>{T(TKey.MESSAGES_CONTENT_CARD_TITLE)}</h4>
      </div>

      <p className={styles.desc}>{T(TKey.MESSAGES_CONTENT_CARD_DESCRIPTION)}</p>

      <Button
        params={params}
        text={`${T(TKey.MESSAGES_CONTENT_CARD_CTA)} →`}
        href={URLs.pathOf(Routes.PROTECTED.MESSAGES_CONTENT)}
        type={ButtonType.PRIMARY}
        className={styles.cta}
        min={true}
        isLink={true}
      />
    </div>
  );
}
